import React, { useState } from "react";
import translations from "../locales/translations";

const getInitialLang = () => {
  // Try to get from localStorage or default to English
  return localStorage.getItem("lang") || "en";
};

export const LanguageContext = React.createContext({
  lang: "en",
  setLang: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang());

  const changeLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem("lang", newLang);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  const { lang } = React.useContext(LanguageContext);
  return (key) => translations[lang][key] || key;
};
